import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { HydratedUser } from '../types/compoundModels.ts';

export const USER_QUERY_KEY = 'USER_QUERY_KEY';

const useReadOneById = (
  options?: Partial<UseQueryOptions<HydratedUser | null>>
) =>
  useQuery({
    queryKey: [USER_QUERY_KEY, endpoints.user.read.one.by.id()],
    queryFn: api.user.read.one.by.id,
    ...options,
  });

const userQueryHooks = {
  useReadOneById,
};

export default userQueryHooks;
